module.exports = __webpack_public_path__ + "img/4.74c9b737.png";